



























import Vue from 'vue'
import { MacAddressElInterface } from '@/config/interfaces'

export default Vue.extend({
  name: 'MacAddress',

  data: () => ({
    numOfInputs: 6,
    macAddressArray: [] as Array<string>,
    macAddressKey: 'macaddress'
  }),

  computed: {
    macAddress () {
      return this.macAddressArray.join('')
    }
  },

  methods: {
    inputMacAddress (e: KeyboardEvent) {
      const currInput = e.target as HTMLInputElement
      const nextId = parseInt(currInput.name.slice(this.macAddressKey.length)) + 1
      if (nextId < this.numOfInputs && currInput.value.length > 1) {
        const el = this.$refs[this.macAddressKey + nextId] as Array<HTMLInputElement>
        // Select next input on next re-render
        this.$nextTick(() => el[0].focus())
      }
    },
    deleteInput (e: KeyboardEvent): void {
      const keyPressed = e.code
      const currInput = e.target as HTMLInputElement
      // Deletion only available with these keys
      if (keyPressed === 'Backspace' || keyPressed === 'Delete' || e.key === 'Backspace') {
        const currId = parseInt(currInput.name.slice(this.macAddressKey.length))
        const prevId = currId - 1
        // Make sure to clear the current value from array
        if (!this.macAddressArray[currId]) {
          this.macAddressArray[currId] = ''
          if (prevId >= 0) {
            const el = this.$refs[this.macAddressKey + prevId] as Array<HTMLInputElement>
            this.$nextTick(() => el[0].focus())
          }
        }
      }
    }
  },
  props: {
    templateItemData: {
      type: Object as () => MacAddressElInterface,
      required: true
    }
  }
})
